<template>
  <div class="registration-page">
    <div class="section-header">
      <h3>参会记录</h3>
    </div>

    <div v-if="registrations.length === 0" class="empty-state">
      <i class="el-icon-tickets"></i>
      <p>暂无参会记录</p>
      <el-button type="primary" @click="$router.push('/pay')">立即报名</el-button>
    </div>

    <div v-else class="registration-list">
      <div v-for="item in registrations" :key="item.id" class="registration-item">
        <div class="item-header">
          <h4 class="item-title">{{ item.conference_title }}</h4>
          <el-tag 
            :type="getPayStatusType(item.pay_status)" 
            size="small"
          >
            {{ getPayStatusText(item.pay_status) }}
          </el-tag>
        </div>
        
        <div class="item-info">
          <div class="info-row">
            <span class="info-label">订单编号：</span>
            <span class="info-value">{{ item.order_no }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">报名时间：</span>
            <span class="info-value">{{ formatDate(item.createtime) }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">报名费用：</span>
            <span class="info-value price">¥{{ item.amount }}</span>
          </div>
          <div class="info-row" v-if="item.pay_time">
            <span class="info-label">支付时间：</span>
            <span class="info-value">{{ formatDate(item.pay_time) }}</span>
          </div>
        </div>

        <div class="item-actions">
          <el-button 
            v-if="item.pay_status === 0" 
            type="primary" 
            size="small"
            @click="goToPay(item)"
          >
            立即支付
          </el-button>
          <el-button 
            v-if="item.pay_status === 1" 
            type="success" 
            size="small"
            plain
          >
            <i class="el-icon-download"></i> 下载电子票
          </el-button>
          <el-button 
            v-if="item.pay_status === 0" 
            type="danger" 
            size="small"
            plain
            @click="cancelRegistration(item)"
          >
            取消报名
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { registrationApi } from '@/api'
import { formatDate, getPayStatusText, getPayStatusType } from '@/utils'

export default {
  name: 'UserRegistration',
  data() {
    return {
      registrations: [
        {
          id: 1,
          order_no: 'REG202501150001',
          conference_title: '第一届明安图天文前沿论坛',
          amount: '800.00',
          pay_status: 1,
          pay_time: 1705286400,
          createtime: 1705200000
        },
        {
          id: 2,
          order_no: 'REG202501160002',
          conference_title: '第一届明安图天文前沿论坛',
          amount: '600.00',
          pay_status: 0,
          pay_time: 0,
          createtime: 1705300000
        }
      ]
    }
  },
  methods: {
    formatDate,
    getPayStatusText,
    getPayStatusType,
    async fetchRegistrations() {
      try {
        const res = await registrationApi.getMyRegistrations()
        if (res.data) {
          this.registrations = res.data.list || []
        }
      } catch (error) {
        console.error('获取参会记录失败:', error)
      }
    },
    goToPay(item) {
      this.$router.push({ path: '/pay', query: { order_no: item.order_no } })
    },
    cancelRegistration(item) {
      this.$confirm('确定要取消此报名吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message.success('已取消报名')
        // 实际调用API取消
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.registration-page {
  background: #fff;
  border-radius: 16px;
  padding: 30px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.section-header {
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 2px solid #f0f0f0;

  h3 {
    font-size: 20px;
    color: #1a237e;
    margin: 0;
  }
}

.empty-state {
  text-align: center;
  padding: 60px 0;
  color: #999;

  i {
    font-size: 64px;
    margin-bottom: 16px;
  }

  p {
    font-size: 16px;
    margin-bottom: 24px;
  }
}

.registration-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.registration-item {
  background: #f8f9fc;
  border-radius: 12px;
  padding: 24px;
  transition: all 0.3s;

  &:hover {
    background: #f0f2f8;
  }
}

.item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  .item-title {
    font-size: 18px;
    font-weight: 600;
    color: #1a237e;
    margin: 0;
  }
}

.item-info {
  margin-bottom: 16px;
}

.info-row {
  display: flex;
  margin-bottom: 8px;
  font-size: 14px;

  .info-label {
    color: #999;
    min-width: 80px;
  }

  .info-value {
    color: #333;

    &.price {
      color: #f56c6c;
      font-weight: 600;
    }
  }
}

.item-actions {
  display: flex;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px dashed #e0e0e0;
}
</style>
